import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
		clsx,
	} from "clsx"

	import {
		DialogDescription,
	} from "@headlessui/vue"

	import VText from "@/components/Text/VText.vue"

	
export default /*@__PURE__*/_defineComponent({
  __name: 'VAlertDescription',
  props: {
		className: {
			type: String,
			default: "",
		},
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogDescription), {
    as: VText,
    class: _normalizeClass(_unref(clsx)(__props.className, 'mt-2 text-pretty text-center sm:text-left'))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})